package com.ervasstudio.tracoemovimento.pages.cursos.signup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.varabyte.kobweb.compose.css.verticalAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@Composable
fun SegundaEtapaSignUp(
    senha: String,
    repeticaoSenha: String,
    onSenhaChange: (senha: String) -> Unit,
    onRepeticaoSenhaChange: (repeticaoSenha: String) -> Unit,
    onCadastrarClick: () -> Unit,
    isMobile: Boolean,
) {
    var senhaError by remember { mutableStateOf<String?>(null) }
    var repeticaoSenhaError by remember { mutableStateOf<String?>(null) }
    var isCadastrando by remember { mutableStateOf(false) }
    var mostrarSenha by remember { mutableStateOf(false) }
    var mostrarRepeticaoSenha by remember { mutableStateOf(false) }

    val alturaCampo = if (isMobile) 44.px else 48.px   // era 48.px fixo
    val fontErro = if (isMobile) 11.px else 12.px       // era 12.px fixo
    val paddingEsquerdoInput = if (isMobile) 16.px else 20.px   // era left = 20.px fixo

    // ---------------------------------------------------------
    // SENHA
    // ---------------------------------------------------------
    Div(attrs = { style { position(Position.Relative); width(100.percent) } }) {
        Input(
            type = if (mostrarSenha) InputType.Text else InputType.Password,
            value = senha,
            onValueChange = {
                onSenhaChange(it)
                if (senhaError != null) senhaError = null
            },
            placeholder = "Senha",
            modifier = inputModifier(alturaCampo)
                .padding(right = 50.px, left = paddingEsquerdoInput)
                .margin(bottom = if (senhaError != null) 2.px else 12.px)
        )

        Button(
            onClick = { mostrarSenha = !mostrarSenha },
            modifier = Modifier
                .position(Position.Absolute)
                .right(8.px).top(0.px)
                .width(40.px).height(alturaCampo)   // era height(48.px)
                .display(DisplayStyle.Flex)
                .alignItems(AlignItems.Center)
                .justifyContent(JustifyContent.Center)
                .backgroundColor(Colors.Transparent)
                .styleModifier {
                    property("border", "none")
                    property("cursor", "pointer")
                    property("padding", "0")
                }
        ) {
            SpanText(
                if (mostrarSenha) "👁" else "👁",
                Modifier.fontSize(if (isMobile) 16.px else 18.px).color(Colors.Gray)   // era 18.px
            )
        }
    }

    senhaError?.let {
        SpanText(it, Modifier.color(Colors.Red).fontSize(fontErro).margin(bottom = 12.px).fontFamily("GothamBook"))
    }

    // ---------------------------------------------------------
    // REPETIÇÃO DA SENHA
    // ---------------------------------------------------------
    Div(attrs = { style { position(Position.Relative); width(100.percent) } }) {
        Input(
            type = if (mostrarRepeticaoSenha) InputType.Text else InputType.Password,
            value = repeticaoSenha,
            onValueChange = {
                onRepeticaoSenhaChange(it)
                if (repeticaoSenhaError != null) repeticaoSenhaError = null
            },
            placeholder = "Repita a senha",
            modifier = inputModifier(alturaCampo)
                .padding(right = 50.px, left = paddingEsquerdoInput)
                .margin(bottom = if (repeticaoSenhaError != null) 2.px else 12.px)
        )

        Button(
            onClick = { mostrarRepeticaoSenha = !mostrarRepeticaoSenha },
            modifier = Modifier
                .position(Position.Absolute)
                .right(8.px).top(0.px)
                .width(40.px).height(alturaCampo)   // era height(48.px)
                .display(DisplayStyle.Flex)
                .alignItems(AlignItems.Center)
                .justifyContent(JustifyContent.Center)
                .backgroundColor(Colors.Transparent)
                .styleModifier {
                    property("border", "none")
                    property("cursor", "pointer")
                    property("padding", "0")
                }
        ) {
            SpanText(
                if (mostrarRepeticaoSenha) "👁" else "👁",
                Modifier.fontSize(if (isMobile) 16.px else 18.px).color(Colors.Gray)   // era 18.px
            )
        }
    }

    repeticaoSenhaError?.let {
        SpanText(it, Modifier.color(Colors.Red).fontSize(fontErro).margin(bottom = 12.px).fontFamily("GothamBook"))
    }

    // ---------------------------------------------------------
    // BOTÃO
    // ---------------------------------------------------------
    Button(
        onClick = {
            if (isCadastrando) return@Button
            senhaError = null
            repeticaoSenhaError = null
            var isValid = true

            when {
                senha.isBlank() -> {
                    senhaError = "Digite uma senha."
                    isValid = false
                }
                senha.length < 8 -> {
                    senhaError = "A senha deve ter pelo menos 8 caracteres."
                    isValid = false
                }
                !senha.any { it.isLetter() } -> {
                    senhaError = "A senha deve conter pelo menos uma letra."
                    isValid = false
                }
                !senha.any { it.isDigit() } -> {
                    senhaError = "A senha deve conter pelo menos um número."
                    isValid = false
                }
            }

            if (repeticaoSenha.isBlank()) {
                repeticaoSenhaError = "Repita a sua senha."
                isValid = false
            } else if (senha != repeticaoSenha) {
                repeticaoSenhaError = "As senhas não coincidem."
                isValid = false
            }

            if (isValid) {
                isCadastrando = true
                onCadastrarClick()
            }
        },
        modifier = Modifier
            .fillMaxWidth()
            .height(alturaCampo)   // era height(48.px)
            .borderRadius(24.px)
            .backgroundColor(Lilas)
            .styleModifier {
                property("border", "none")
                property("cursor", "pointer")
            }
    ) {
        SpanText(
            if (isCadastrando) "Cadastrando" else "Cadastrar",
            Modifier.fontFamily("GothamBlack").fontSize(if (isMobile) 14.px else 16.px).color(White)   // era sem fontSize
        )
    }
}

private fun inputModifier(altura: CSSSizeValue<CSSUnit.px> = 48.px) = Modifier
    .fillMaxWidth()
    .height(altura)   // era height(48.px) fixo
    .borderRadius(24.px)
    .border(1.px, LineStyle.Solid, Colors.Black)
    .padding(leftRight = 16.px)
    .styleModifier {
        property("outline", "none")
    }